export default __webpack_public_path__ + "static/media/022-extinguisher.88fe05ba.png";